<template>
  <div class="projects-view">
    <div class="py-2">
      <ProjectsColumn
        title="Dossier en cours de finalisation"
        :projects="filteredGroupByProgress['docsLease'] || []"
        v-if="showColumn('docsLease')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Recherche démarrée"
        :projects="filteredGroupByProgress['researchStarted'] || []"
        v-if="showColumn('researchStarted')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Proposition visite"
        :readOnly="true"
        :projects="filteredGroupByProgress['visitScheduled'] || []"
        v-if="showColumn('visitScheduled')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Dossier accepté/Bail en cours"
        description="En attente de signature"
        :projects="filteredGroupByProgress['caseAccepted'] || []"
        v-if="showColumn('caseAccepted')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Bail signé"
        :projects="filteredGroupByProgress['leaseFetched'] || []"
        v-if="showColumn('leaseFetched')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Signature MP et CR en cours"
        :projects="filteredGroupByProgress['awaitingSignature'] || []"
        v-if="showColumn('awaitingSignature')"
        @moveStart="dragging = false"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Constitution dossier final"
        :projects="filteredGroupByProgress['signed'] || []"
        v-if="showColumn('signed')"
        @moveStart="dragging = false"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Soumis à HiL"
        :projects="filteredGroupByProgress['submittedToHil'] || []"
        v-if="showColumn('submittedToHil')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Nouveaux inscrits"
        :projects="filteredGroupByProgress['projectCreated'] || []"
        v-if="showColumn('projectCreated')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="A rappeler"
        description="Le client n'a pas répondu"
        :projects="filteredGroupByProgress['toCall'] || []"
        v-if="showColumn('toCall')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Dossier en attente"
        description="Contact établi, en attente d'éligibilité"
        :projects="filteredGroupByProgress['eligibility'] || []"
        v-if="showColumn('eligibility')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Dossier en cours"
        description="Contact établi, candidat éligible"
        :projects="filteredGroupByProgress['docsMobiPass'] || []"
        v-if="showColumn('docsMobiPass')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="A répartir"
        :projects="filteredGroupByProgress['toAssign'] || []"
        v-if="showColumn('toAssign')"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Envoyé à AL"
        description="Validé par Eva"
        v-if="showColumn('sentToAL')"
        :projects="filteredGroupByProgress['sentToAL'] || []"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Relance"
        v-if="showColumn('relanceAL')"
        :projects="filteredGroupByProgress['relanceAL'] || []"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Payé"
        v-if="showColumn('paid')"
        :canUpdate="p => p.assignees.reloc != null"
        :projects="filteredGroupByProgress['paid'] || []"
        @moveStart="dragging = true"
        @moveEnd="dragging = false"
        :dragging="dragging"
        @update="$emit('update')"
      />
      <ProjectsColumn
        title="Tous"
        :projects="filtered"
        v-if="$mq === 'sm' && column === 'all'"
      />
    </div>
  </div>
</template>

<script>
import ProjectsColumn from "./ProjectsColumn";
import { mapGetters, mapState } from "vuex";
export default {
  name: "ProjectsView",
  components: { ProjectsColumn },
  props: { column: { type: String } },

  data: function() {
    return {
      dragging: false,
    };
  },
  methods: {
    showColumn(col) {
      /**
       * Only show a column if it is included in the list of columns and:
       * - if the column is the one selected or,
       * - if the column is "all" and the device is not mobile
       * Mobile devices are not supposed to show all columns separately (single column mode)
       */
      return (
        this.columns.includes(col) &&
        (this.column === col || (this.column === "all" && this.$mq !== "sm"))
      );
    }
  },
  computed: {
    ...mapState("user", ["role"]),
    ...mapState("projects", ["columns"]),
    ...mapGetters("projects", ["filtered", "filteredGroupByProgress"])
  }
};
</script>

<style scoped>
.projects-view {
  position: absolute;
  top: 160px;
  bottom: 10px;
  left: 0;
  right: 0;

  overflow: auto;
}

@media screen and (max-width: 450px) {
  .projects-view {
    position: static;
    overflow: visible;
  }
}

.projects-view > div {
  display: flex;
}
</style>
